var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTrainerManagement = function SvgTrainerManagement(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-940.000000, -850.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Telefit",
    transform: "translate(920.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Telefit-List",
    transform: "translate(0.000000, 417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 8,
    transform: "translate(0.000000, 420.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left-Copy-5",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.771556,13.7337043 C18.7475254,14.4293635 21.8241129,15.8742278 21.9927381,18.0607662 L22,18.25 L22,22 L2,22 L2,18.25 C2,15.9658674 5.14410142,14.4603866 8.19453587,13.741662 L11.385,17.35 L10,19.7493317 L12.1662211,21 L14.0422236,17.7506683 L12.816,17.042 L15.771556,13.7337043 Z M12,13.25 C12.673353,13.25 13.4820486,13.3181801 14.3440666,13.4543351 L11.965,16.118 L9.61474923,13.4608854 C10.4921845,13.3203669 11.315934,13.25 12,13.25 Z M12,2 C14.7614237,2 17,4.23857625 17,7 C17,9.76142375 14.7614237,12 12,12 C9.23857625,12 7,9.76142375 7,7 C7,4.23857625 9.23857625,2 12,2 Z",
    id: "Combined-Shape",
    fill: "#F6F7FA"
  }))))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTrainerManagement, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trainer-management.4d5306c3.svg";
export { ForwardRef as ReactComponent };